import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7f80260f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-container py-5" }
const _hoisted_2 = { class: "row g-4 d-flex align-items-stretch" }
const _hoisted_3 = { class: "col-12 d-flex" }
const _hoisted_4 = { class: "admin-card flex-fill" }
const _hoisted_5 = { class: "staff-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "block-title" }, "Personnel Administratif", -1))
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "staff-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "staff-name" }, "Sr Marcelle Aholou", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "role" }, "Assistante de direction", -1))
const _hoisted_11 = { class: "staff-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "staff-name" }, "Josith Adiho", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "role" }, "Secrétaire académique & Comptabilité", -1))
const _hoisted_14 = { class: "staff-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "staff-name" }, "da Silva Péroline", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "role" }, "Assistante au Secrétariat", -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-6 d-flex\" data-v-7f80260f><div class=\"admin-card flex-fill\" data-v-7f80260f><div class=\"schedule-block\" data-v-7f80260f><h2 class=\"block-title\" data-v-7f80260f>Accueil &amp; Secrétariat</h2><div class=\"schedule\" data-v-7f80260f><p data-v-7f80260f><strong data-v-7f80260f>Lundi, Mardi, Jeudi, Vendredi :</strong> 9h – 13h &amp; 15h30 – 20h30</p><p data-v-7f80260f><strong data-v-7f80260f>Mercredi :</strong> 16h – 20h30</p><p data-v-7f80260f><strong data-v-7f80260f>Samedi :</strong> 8h30 – 13h</p></div></div></div></div><div class=\"col-12 col-md-6 d-flex\" data-v-7f80260f><div class=\"admin-card flex-fill\" data-v-7f80260f><div class=\"schedule-block\" data-v-7f80260f><h2 class=\"block-title\" data-v-7f80260f>Informations bancaires</h2><div class=\"schedule\" data-v-7f80260f><p data-v-7f80260f><strong data-v-7f80260f>Banque UBA</strong>n° 501100007916 </p><p data-v-7f80260f><strong data-v-7f80260f>Iban :</strong>BJ0670150150110000791654. </p><p data-v-7f80260f><strong data-v-7f80260f>Code SWIFT/BIC :</strong> COBBBJBJ</p><p data-v-7f80260f><strong data-v-7f80260f>Titulaire : </strong>ECOLE D’INITIATION THEOLOGIQUE ET PASTORALE.</p></div></div></div></div>", 2)
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "col-12 col-md-4",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('/Soeur AHOLOU Marcelle.JPG')))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: "/Soeur AHOLOU Marcelle.JPG",
                      class: "staff-photo",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('/Soeur AHOLOU Marcelle.JPG')))
                    }),
                    _hoisted_9,
                    _hoisted_10
                  ])
                ]),
                _createElementVNode("div", {
                  class: "col-12 col-md-4",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('/ADIHO Josith.jpg')))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: "/ADIHO Josith.jpg",
                      class: "staff-photo",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('/ADIHO Josith.jpg')))
                    }),
                    _hoisted_12,
                    _hoisted_13
                  ])
                ]),
                _createElementVNode("div", {
                  class: "col-12 col-md-4",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('/da SILVA Péroline .jpg')))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: "/da SILVA Péroline .jpg",
                      class: "staff-photo",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('/da SILVA Péroline .jpg')))
                    }),
                    _hoisted_15,
                    _hoisted_16
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_17
      ])
    ]),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-modal",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", {
              class: "close-btn",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "×"),
            _createElementVNode("img", {
              src: _ctx.selectedImage,
              class: "modal-image"
            }, null, 8, _hoisted_20)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}